import React, { Fragment } from 'react';
import { AutoComplete, Button, Form, Input, Modal, notification, Select, Typography } from "antd";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import ApiService from "../../../services/ApiService";

const { Search } = Input;
const { Text } = Typography;
const { Option } = Select;

export default class ModalAddTel extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this);
    }

    initialState = {
        visible: false,
        loading: false,
        contactId: null,
        id: null,
        edit: false,
        adresses: [],
        defaultData: {}
    };

    state = this.initialState;

    async show(contactId, data = {}, adresses = []) {
        if (data.id) {
            this.setState({
                visible: true,
                edit: true,
                adresses: adresses,
                contactId: contactId,
                id: data.id,
                defaultData: { ...data }
            });
        } else {
            this.setState({ visible: true, adresses: adresses, contactId: contactId });
        }
    }

    close() {
        this.setState(this.initialState);
    }

    async onSubmit(data) {
        if (this.state.id) {
            data.id = this.state.id;
        }

        this.setState({ loading: true });

        var res = await ApiService.post("/contact/tel/edit/" + this.state.contactId, data);

        if (res.success) {
            if (res.message) {
                notification.warn({
                    message: res.message
                });
            } else {
                notification.success({
                    message: this.state.edit ? t`Modification réussie` : t`Ajout réussi`
                });
            }

            this.close();
            if (this.props.onFinish) {
                this.props.onFinish(res.data);
            }
        } else {
            notification.error({
                message: this.state.edit ? t`Erreur lors de la modification` : t`Erreur lors de l’ajout`
            });
        }

        this.setState({ loading: false });
    }

    render() {
        return (
            <Modal
                width="100%"
                title={this.state.id ? t`Éditer un Numéro de Téléphone` : t`Ajouter un Numéro de Téléphone`}
                open={this.state.visible}
                destroyOnClose
                closable
                footer={null}
                onCancel={() => this.close()}
            >
                <Form
                    onFinish={(data) => this.onSubmit(data)}
                    ref={(ref) => this.form = ref}
                    layout={"vertical"}
                    initialValues={this.state.defaultData}
                >
                    <Form.Item
                        label={t`Type de Téléphone`}
                        name="type"
                        rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                    >
                        <AutoComplete
                            options={[t`Domicile`, t`Société`, t`Bureau`, t`Autre`].map(i => ({ value: i }))}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        >
                            <Input placeholder={t`Type de Téléphone`} />
                        </AutoComplete>
                    </Form.Item>

                    <Form.Item
                        label={t`Numéro de Téléphone`}
                        name="number"
                        rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                    >
                        <Input placeholder={t`Numéro de Téléphone`} />
                    </Form.Item>

                    {this.state.adresses.length > 0 && (
                        <Form.Item
                            label={t`Adresse`}
                            name="adresseId"
                        >
                            <Select style={{ width: "100%" }} placeholder={t`Lier avec une Adresse`}>
                                {this.state.adresses.map(i => {
                                    return (
                                        <Select.Option value={i.id}>
                                            {i.siren && (
                                                <Fragment>
                                                    <Trans>Société</Trans>: {i.nom} ({i.siren})
                                                    - {i.adresse}, {i.postal}, {i.ville}, {i.pays}
                                                </Fragment>
                                            )}

                                            {!i.siren && (
                                                <Fragment>
                                                    {i.nom} - {i.adresse}, {i.postal}, {i.ville}, {i.pays}
                                                </Fragment>
                                            )}
                                        </Select.Option>
                                    );
                                })}
                            </Select>
                        </Form.Item>
                    )}

                    <Form.Item style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button type="primary" htmlType="submit" loading={this.state.loading}>
                            <Trans>Valider</Trans>
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}
